export const environment = {
    production: false,
    googleMapsMapId: 'DEMO_MAP_ID',
    baseUrl: 'https://speedtaxi.catalin2402.ddns.net',
    driverResourcesUrl: 'https://speedtaxi.catalin2402.ddns.net/soc-admin/v1/driverimage/'
};
